// The download buttons point to our own /download/<platform>/ address (a page
// of this site, so the visit shows in the server logs with its utm_* tags),
// which then sends the browser to the installer on GitHub.
export const RELEASES_URL = 'https://github.com/CloudPouch/CloudPouch.dev/releases';

// slug: the address segment; ext: the installer file type (as in latestInstallers.js).
export const DOWNLOAD_PLATFORMS = {
  mac: { name: 'Mac', ext: 'dmg' },
  windows: { name: 'Windows', ext: 'exe' },
  linux: { name: 'Linux', ext: 'AppImage' },
};

export const downloadPath = (slug) => `/download/${slug}/`;
